if (!process.env.NEXT_PUBLIC_BUILDER_PUBLIC_KEY) {
  throw new Error('Missing env variable NEXT_PUBLIC_BUILDER_PUBLIC_KEY');
}

export const API_KEY = process.env.NEXT_PUBLIC_BUILDER_PUBLIC_KEY;
